// extracted by mini-css-extract-plugin
export var dropdownContainer = "_qz-0";
export var leftAlign = "_qz-4";
export var listItem = "_qz-2";
export var listItemWrapper = "_qz-1";
export var operationText = "_qz-3";